var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconEarthEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 22.63A11.25 11.25 0 1 1 22.61 8.26",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5 20.8 1-5.05h1.08a1.48 1.48 0 0 0 1.18-.58 1.44 1.44 0 0 0 .27-1.28l-.75-3a1.49 1.49 0 0 0-1.45-1.14H1m20-4.5h-4.08a1.49 1.49 0 0 0-1.45 1.14l-1.77 7.07m8.93 1.41L15 22.5l-3.75.75.75-3.75 7.63-7.63a2.11 2.11 0 0 1 3 0 2.11 2.11 0 0 1 0 3Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconEarthEdit);
export default __webpack_public_path__ + "static/media/streamline-icon-earth-edit.35a276fb.svg";
export { ForwardRef as ReactComponent };